import { computeAnchoredPanelStyle } from '@/utils/workflowPopoverAnchor'

export default {
  props: {
    anchorRect: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      _repositionHandler: null
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        if (v) {
          this.$nextTick(() => {
            this.portalToBody()
            this.bindReposition()
          })
        } else {
          this.unbindReposition()
        }
      }
    },
    anchorRect: {
      deep: true,
      handler() {
        if (this.visible) this.$forceUpdate()
      }
    }
  },
  beforeDestroy() {
    this.unbindReposition()
  },
  methods: {
    getPanelLayoutOptions() {
      return { panelWidth: 420, panelMaxHeight: 480, gap: 10, align: 'left' }
    },
    buildPanelPositionStyle() {
      return computeAnchoredPanelStyle(this.anchorRect, this.getPanelLayoutOptions())
    },
    portalToBody() {
      if (!this.$el || this.$el.parentNode === document.body) return
      try {
        document.body.appendChild(this.$el)
      } catch (e) {
        /* ignore */
      }
    },
    bindReposition() {
      this.unbindReposition()
      this._repositionHandler = () => {
        this.$forceUpdate()
      }
      window.addEventListener('resize', this._repositionHandler, { passive: true })
      window.addEventListener('scroll', this._repositionHandler, { passive: true, capture: true })
    },
    unbindReposition() {
      if (!this._repositionHandler) return
      window.removeEventListener('resize', this._repositionHandler)
      window.removeEventListener('scroll', this._repositionHandler, true)
      this._repositionHandler = null
    }
  }
}
